import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 *
 * */
@Component({
  selector: 'campfire-support-request-modal',
  templateUrl: './support-request.modal.component.html',
  styleUrls: ['./support-request.modal.component.scss']
})
export class SupportRequestModalComponent {
  constructor(private modal: NgbActiveModal) {

  }
}

